import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getProviderPaymentList } from "../slice/providerPaymentSettingSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";

const ProviderPanelPaymentSent = () => {
    const dispatch = useDispatch();
    const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
    const { providerList } = useSelector((state) => state.providerPaymentSetting);

    const providerToken = localStorage.getItem("provider_access_token");

    useEffect(() => {
        dispatch(getProviderPaymentList(providerToken));
    }, [dispatch]);

    const sortedData = [...providerList].sort((a, b) => {
      if (sortConfig.column === null) return 0;

      const key = sortConfig.column;

      const valA = a[key] ?? "";
      const valB = b[key] ?? "";

        if (!isNaN(valA) && !isNaN(valB)) {
            return sortConfig.direction === "asc"
                ? valA - valB
                : valB - valA;
        } else {
            return sortConfig.direction === "asc"
                ? valA.toString().localeCompare(valB.toString())
                : valB.toString().localeCompare(valA.toString());
        }
    });

    const handleSort = (columnKey) => {
        let direction = "asc";
        if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ column: columnKey, direction });
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2); // Month is 0-indexed, so add 1
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);
        const seconds = ("0" + date.getSeconds()).slice(-2);
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    

    return (
        <>
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                     <div className="ps-2 ps-lg-4">
                        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex align-items-center">
                           My Subscriptions
                           <Link className="btn btn-danger ms-auto py-2" to="/provider-plans"><i class="fa fa-user-plus me-1"></i> Provider Plans</Link>
                        </h4>
                        <div className="table-responsive">
                           <table className="table table-striped table-bordered align-middle text-muted" id="servicesTable">
                              <thead>
                                 <tr>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("created_at")}>Plan Name<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="10%" className="font-weight-semibold" onClick={() => handleSort("amount")}>Amount<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="10%" className="font-weight-semibold" onClick={() => handleSort("stripe_payment_id")}>Stripe Payment ID <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="10%" className="font-weight-semibold" onClick={() => handleSort("status")}>Status <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="12%" className="font-weight-semibold" onClick={() => handleSort("start_date")}>Start Date<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="12%" className="font-weight-semibold" onClick={() => handleSort("end_date")}>End Date<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="15%" className="font-weight-semibold" onClick={() => handleSort("created_at")}>Payment Date<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                 </tr>
                              </thead>
                              <tbody>
                                {sortedData.length > 0 ? (
                                    sortedData.map((provider, index) => (
                                       <tr key={index}>
                                       <td>{provider.providerPlan.plan_title}</td>
                                       <td>${provider.amount}</td>
                                       <td>{provider.stripe_payment_id}</td>
                                       <td>{provider.status}</td>
                                       <td>{provider.start_date}</td>
                                       <td>{provider.end_date}</td>
                                       <td>{formatDate(provider.created_at)}</td>
                                       </tr>
                                    ))
                                 ) : (
                                    <tr>
                                       <td colSpan="4" className="text-center">No data found.</td>
                                    </tr>
                                 )}
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
        </>
    );

};

export default ProviderPanelPaymentSent;
